<template>
  <a-col>
    <a-col class="form-input-margin">
      <a-col class="form-input-title"> Язык </a-col>
      <lang-tabs v-model="langTab" />
    </a-col>

    <a-col class="form-input-margin">
      <a-col class="form-input-title"> Название тега </a-col>
      <a-input
        v-model="form.name[langTab]"
        placeholder="Введите название тега"
        :spell-check="false"
      />
    </a-col>

    <a-col class="form-input-margin">
      <a-col class="form-input-title"> Статус </a-col>
      <a-switch v-model="form.status" />
    </a-col>

    <a-row type="flex" justify="end">
      <a-button @click="$emit('cancel', $event)"> Отмена </a-button>
      <a-button type="primary" @click="emitForm"> ОК </a-button>
    </a-row>
  </a-col>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      // required: true
      default: () => ({
        name: {
          uz: "",
          oz: "",
          ru: "",
          en: ""
        },
        status: true
      })
    }
  },
  data: () => ({
    form: {},
    // eslint-disable-next-line no-undef
    langTab: $langPrefix
  }),
  beforeMount() {
    if (this.data) {
      const {
        // eslint-disable-next-line no-unused-vars
        created,
        // eslint-disable-next-line no-unused-vars
        updated,
        ...props
      } = this.data

      // Object.keys(props.name).forEach( item => {
      //   if(props.name[item]){
      //     props.name[item] = this.data.name[item]
      //   }
      // })

      // console.log('props', props);

      this.$set(this, "form", {
        ...props,
        name: {
          // set default lang keys uz: "", oz: "", ru: "", en: ""
          ...this.langKeys,
          ...props.name
        }
      })
    }
  },
  methods: {
    emitForm() {
      this.$emit("submit", this.form)
    }
  }
}
</script>
